import VehicleTable from './VehicleTable';

export default VehicleTable;
